/**
 * ScoresPage Component
 *
 * Standalone page for managing score templates
 * Supports filtering by category via query parameter
 */

import { useSearchParams, Link } from 'react-router-dom';

import ScoresEditor from './entities/ScoresEditor';

export default function ScoresPage() {
  const [searchParams] = useSearchParams();
  const categoryParam = searchParams.get('category');

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900">
      {/* Header */}
      <div className="bg-white dark:bg-gray-800 border-b border-gray-200 dark:border-gray-700">
        <div className="px-6 py-4">
          <div className="flex items-center justify-between">
            <div>
              <h1 className="text-2xl font-bold text-gray-900 dark:text-gray-100">
                Score Templates
              </h1>
              <p className="text-sm text-gray-600 dark:text-gray-400 mt-1">
                Manage score template definitions for investments
              </p>
            </div>
            <Link
              to="/admin"
              className="text-sm text-indigo-600 dark:text-indigo-400 hover:text-indigo-900 dark:hover:text-indigo-300"
            >
              ← Back to Admin
            </Link>
          </div>
        </div>
      </div>

      {/* Main Content */}
      <div className="p-6">
        <div className="bg-white dark:bg-gray-800 rounded-lg shadow p-6">
          <ScoresEditor initialCategoryId={categoryParam ? Number(categoryParam) : undefined} />
        </div>
      </div>
    </div>
  );
}
